import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FundHistoryService} from '../shared/services/fund-history.service';
import {AdminService} from '../shared/services/admin.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TopbarComponent } from '../shared/components/topbar/topbar.component';
import { SidebarComponent } from '../shared/components/sidebar/sidebar.component';
import { BottombarComponent } from '../shared/components/bottombar/bottombar.component';
import { FundHistoryModalComponent } from './fund-history-modal/fund-history-modal.component';
import { FundHistoryFilterComponent } from './fund-history-filter/fund-history-filter.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-fund-history',
    templateUrl: './fund-history.component.html',
    styleUrls: ['./fund-history.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent,
        FundHistoryModalComponent,
        FundHistoryFilterComponent
    ]
})
export class FundHistoryComponent implements OnInit {
  showFilter: boolean = false;
  showViewer: boolean = false;
  transactions;
  funds;
  emptyHistoryMessage: string = 'Fund History is empty.';
  sortType: string;
  sortReverse: boolean = false;
  config: any;
  title;
  navigationSubscription;
  status;
  response;
  isLive;
  details;

  constructor(private adminService: AdminService, private router: Router, private toastrService: ToastrService,
              private fundHistory: FundHistoryService, private cdr: ChangeDetectorRef) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.initialiseHistories();
      }
    });
  }

  ngOnInit() {
    this.getDetails();
    this.getAll();
  }

  initialiseHistories() {
    this.getAll();
  }
  getDetails() {
    this.adminService.getDetails().subscribe(
      data => {
        this.details = data[0];
        this.refresh();
      });
  }

  refresh() {
    try {
      this.cdr.detectChanges();
    } catch (e) { void e; }
  }

  getAll() {
    this.fundHistory.getAll().subscribe(
      data => {
        this.funds = data;
        this.config = {
          itemsPerPage: 10,
          currentPage: 1,
          totalItems: data.length
        };
        this.refresh();
      }
    );
  }

  getFilteredHistorys(event) {
    this.funds = event.data;
    this.emptyHistoryMessage = 'Filter Result: 0 No matching records.';
    this.refresh();
  }
  onShowFilter() {
    this.showFilter = true;
  }

  onCloseFilter(data) {
    this.showFilter = data;
  }


// Sort
  sortOrders(property) {
    this.sortType = property;
    this.sortReverse = !this.sortReverse;
    this.funds.sort(this.dynamicSort(property));
  }
  dynamicSort(property) {
    let sortOrder = -1;

    if (this.sortReverse) {
      sortOrder = 1;
    }

    return (a, b) => {
      const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }


  pageChanged(event) {
    this.config.currentPage = event;
    this.refresh();
  }

}
